import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHome, faUser, faPersonFalling} from '@fortawesome/free-solid-svg-icons';
import {Link} from 'react-router-dom';

import '../css/style.css';
import '../css/bootstrap.css';

function Index() {
  return (
      <div className="Index">
        <section id="menu">
          <div className="container-fluid">
          <div className="row">
            <div className="col-9">
            </div>
            <div className="col-3">
              <img src="img/Ministerium_logo.png" style={{height: '8vh', selfAlign: 'right'}} alt="Förderlogo des Bayerischen Staatsministeriums für Gesundheit und Pflege" />
            </div>
          </div>
            <div className="row" style={{marginTop:'-5vh'}}>
              <div className="col-4">
                <Link to="tcflabor">
                  <button type="button" className="btn btn-outline-primary" style={{width: '100%', height: '80vh', marginTop: '10vh', marginBottom: '10vh', fontSize: '50vh'}}>
                    <FontAwesomeIcon icon={faHome} />
                  </button>
                </Link>
              </div>
              <div className="col-4">
                <Link to="tcfwatch"><button type="button" className="btn btn-outline-primary" style={{width: '100%', height: '80vh', marginTop: '10vh', marginBottom: '10vh', fontSize: '50vh'}}><FontAwesomeIcon icon={faUser} /></button></Link>
              </div>
              <div className="col-4">
                <Link to="falldetection"><button type="button" className="btn btn-outline-primary" style={{width: '100%', height: '80vh', marginTop: '10vh', marginBottom: '10vh', fontSize: '50vh'}}><FontAwesomeIcon icon={faPersonFalling} /></button></Link>
              </div>
            </div>
            <div className="row">
              <div id="log">
              </div>
            </div>
          </div>
        </section>
      </div>
  );
}

export default Index;
